<template>
  <common-dialog
    :show.sync="innerVisible"
    title="投保确认"
    class="insurance-confirm-dialog"
  >
    <div class="dialog-content">
      <div class="text-content">
        <p>尊敬的客户： </p>
        <p class="indent">您即将进入投保确认环节，应监管部门要求，购买该保险商品需进行投保人信息确认，请点击下方【开始确认】，进入后按页面进行逐步确认完成即可。 </p>
        <p class="indent" v-if="isMultiple">由于该订单有多个投保人，所以需<span class="key-text">确认多次，请依次确认</span>。</p>
      </div>
      <div class="applicant-table" v-if="isMultiple">
        <div class="table-wrapper">
          <table class="s-table" cellspacing="0">
            <thead>
              <tr>
                <th>投保人</th>
                <th>被保人</th>
                <th width="90">确认状态</th>
                <th width="90">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in insureConfirmationApplicantList" :key="index">
                <td :class="[item.err_msg ? 'disabled' : '']">
                  {{ item.cName }}
                </td>
                <td :class="[item.err_msg ? 'disabled flex-box' : '']">
                  <span>{{ item.cName }}</span>
                  <span class="disabled-label" v-if="item.err_msg">不可投保</span>
                </td>
                <td class="center">
                  <span v-if="item.err_msg">--</span>
                  <span :class="['icon', needConfirmIdList.includes(item.cardCode) ? 'no-confirm': 'confirm']" v-else></span>
                </td>
                <td>
                  <span v-if="item.err_msg">--</span>
                  <span class="confirm-btn" @click="onConfirm(item)" v-else-if="needConfirmIdList.includes(item.cardCode)">去确认</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tips">已完成<span class="primary-text"> {{eableOptionList.length - needConfirmIdList.length}}/{{eableOptionList.length}} </span>条款确认</div>
      </div>
    </div>
    <div class="dialog-footer" slot="footer">
      <button @click="onSubmit" class="s-btn btn-blue btn-lg confirm-btn">开始确认</button>
    </div>
  </common-dialog>
</template>
  
<script>
import CommonDialog from '@/components/common/modals/common-dialog/common-dialog.vue';
  
export default {
  components: {
    CommonDialog,
  },
  props: {
    visible: Boolean,
    insureConfirmationApplicantList: {
      type: Array,
      default: () => ([]),
    },
    insuranceId: Number,
  },
  data() {
    return {
      needConfirmIdList: [],
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
    eableOptionList() {
      return this.insureConfirmationApplicantList.filter(it => !it.err_msg);
    },
    // 存在多个申请人需要确认
    isMultiple() {
      return this.insureConfirmationApplicantList && this.insureConfirmationApplicantList.length > 1;
    },
  },
  watch: {
    visible: {
      handler(val) {
        if (val && this.eableOptionList) {
          this.needConfirmIdList = this.eableOptionList.map(it => it.cardCode);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener(
      'message',
      this.confirmMonitor,
      false,
    );
  },
  beforeDestroy() {
    window.removeEventListener('message', this.confirmMonitor);
  },
  methods: {
    // 监听确认
    confirmMonitor(event) {
      console.log('sssssss', event);
      const { card_code, insuranceId } = event.data;

      // 将对应的数据进行重置
      const index = this.needConfirmIdList.findIndex(id => id === card_code);
      console.log('确认的数据', this.needConfirmIdList, card_code);
      if (index !== -1) {
        this.needConfirmIdList.splice(index, 1);  
        // 判断是否没有了，没有则直接跳转到payNow页面
        if (!this.needConfirmIdList.length) {
          this.$router.replace({ name: 'insurancePay', query: { insuranceId: this.insuranceId } });
        }
      }

    },
    onSubmit() {
      // 判断是否有没确认的用户
      if (this.needConfirmIdList.length) {
        const currentInsurce = this.insureConfirmationApplicantList.find(it => it.cardCode === this.needConfirmIdList[0]);
        console.log('打开的链接为', currentInsurce.insure_url);
        window.open(currentInsurce.insure_url, '_blank');
      } else {
        this.innerVisible = false;
        this.$router.replace({ name: 'insurancePay', query: { insuranceId: this.insuranceId } });
      }
    },
    onConfirm(record) {
      if (record) {
        window.open(record.insure_url, '_blank');
      }
    },
  },
};
  </script>
  
<style lang="less" scoped>
.insurance-confirm-dialog {
  /deep/ .el-dialog{
    width: 560px;
    top: 50%!important;
    transform: translate(-50%, -50%);
    .el-dialog__header{
      padding: 0;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      border-bottom: 1px solid #E9EEF2;
      .el-dialog__title{
        color: #2F333D;
        font-size: 20px;
        font-weight: 600;
      }
      .el-dialog__headerbtn{
        position: absolute;
        right: 24px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .el-dialog__body{
      padding: 0;
      .dialog-content{
        padding: 32px 32px 0 32px;
        color: #2F333D;
        font-size: 18px;
        line-height: 30px;
        .text-content {
          .indent {
            text-indent: 2em;
          }
          .key-text {
            font-weight: 600;
          }
        }

        .applicant-table {
          margin-top: 24px;
          .table-wrapper {
            max-height: 340px;
            overflow-y: auto;
          }
          .s-table {
            font-size: 16px;
            color: #2F333D;
            line-height: 22px;
            margin-top: 0;
            thead tr th {
              font-weight: 600;
              white-space: nowrap;
            }
            tbody tr td{
              width: auto;
              height: 52px;
              line-height: 1;
              border-bottom: 1px solid #E9EEF2;
              &.center {
                text-align: center;
              }
              &.disabled {
                // width: 100%;
                height: 100%;
                color: #91999F;
                &.flex-box {
                  display: flex;
                  align-items: center;
                }
                .disabled-label {
                  flex-shrink: 0;
                  padding: 0 8px;
                  color: #5F666E;
                  background-color: rgba(243, 243, 244, 1);
                  font-size: 12px;
                  line-height: 20px;
                  margin-left: 8px;
                }
              }

              // >span {
              //   display: flex;
              //   width: 100%;
              //   &.disabled {
              //     flex: 1;
              //     color: #cfcfcf;
              //     overflow: hidden;
              //     text-overflow: ellipsis;
              //     white-space: nowrap;
              //   }
              //   .label {
              //     flex-shrink: 0;
              //     padding: 4px 8px;
              //     opacity: 0.08;
              //     background-color: rgba(95, 102, 110, .08);
              //     color: #5F666E;
              //     font-size: 12px;
              //     margin-left: 8px;
              //   }
              // } 
            }
            .confirm-btn {
              color: #599FFF;
              cursor: pointer;
            }
            .icon {
              display: inline-block;
              width: 18px;
              height: 18px;
              border-radius: 50%;
            }
            .confirm {
              background: url(../../../../../../../assets/imgs/insurance-new/insurance-info/confirm-icon.png) center center no-repeat;
              background-size: 100% 100%;
            }
            .no-confirm {
              background: url(../../../../../../../assets/imgs/insurance-new/insurance-info/no-confirm-icon.png) center center no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        .tips {
          margin-top: 16px;
          font-size: 16px;
          line-height: 22px;
          .primary-text {
            color: #599FFF;
          }
        }


      }
    }
    .common-dialog-footer {
      display: flex;
      justify-content: center;
      padding: 32px;
      border-top: none;
      .confirm-btn {
        width: 180px;
        height: 48px;
        line-height: 48px;
      }
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/pages/insurance/insuranceOrder/insuranceInfo/components/left-insurance-form/components/insurance-confirm-dialog.vue